import React from "react";
import BaseErrorBoundary from "./BaseErrorBoundary";

class EditorErrorBoundary extends BaseErrorBoundary {
    render() {
        if (this.state.hasError) {
            return (
                <div>
                    <h1>The editor freaked out...</h1>
                    <p>{this.state.errorMessage}</p>
                </div>
            );
        }

        return this.props.children;
    }
}

export default EditorErrorBoundary;
